import {Alarm} from "../../entities/Alarm";
import {AdminPagingModel} from "./AdminPagingModel";
import {GridBookmarkService} from "../../services/GridBookmarkService";
import {AlarmService} from "../../services/AlarmService";
import {NotificationService} from "../../services/NotificationService";

export class AlarmAdminPagingModel extends AdminPagingModel<Alarm>{
    static $inject = ['$q','AlarmService','NotificationService','GridBookmarkService'];
    constructor($q:ng.IQService, pagingService:AlarmService,notificationService:NotificationService,
                gridBookmarkService:GridBookmarkService){
        super($q, pagingService,notificationService,gridBookmarkService);
    }
    getCustomActions():string[]{
        return [];
    }
    entityName():string{
        return "alarm";
    }
    displayName():string{
        return "Alarms";
    }
    addEditAllowed():boolean{
        return false;
    }
    deleteAllowed():boolean{
        return false;
    }
    transformItem(entity:Alarm){
    }
    getColumnDefs():ng.IPromise<void>{
        this.nameValuePairs =
            [
                ['alarmTime','Alarm Time', 200],
                ['rfidTag','Rfid Tag', 215],
                ['readerName','Reader Name', 120],
                ['readerLocation','Reader Location', 140],
                ['assetName','Asset Name', 150],
                ['assetDescription','Asset Description', 150],
                ['alertingActionName','Alerting Action Name', 220],
                ['eventType','Event Type', 110],
                ['thresholdType','Threshold Type', 135],
                ['eventDetails','Event Details', 150],
                ['antennaNumber','Antenna Number', 145],
                ['rSSI','RSSI', 135],
                ['popupRequested','Popup Requested', 135]
            ];
        return this.$q.when();
    }
}
